import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const PlansGridWrapper = styled.div`
  width: 100%;
  display: grid;
  height: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${SPACING._16};
  padding-bottom: ${SPACING._16};

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 750px) {
    grid-template-columns: 1fr;
    padding-bottom: ${SPACING._24};
  }
`;

export const BillingFrequencyToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: ${SPACING._16};
`;
